module.exports = __webpack_public_path__ + "createstatic/media/backBtn.aa46fc88.svg";